import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import {MapComponent} from "./map/map.component";
import {LoginPage} from "./login-page/login.page";
import {AuthGuard} from "./guards/auth.guard";

const routes: Routes = [
  {
    path: "",
    component: MapComponent,
    canActivate: [AuthGuard],
    data: {
      title: "Random Ride - MAP",
    },
  },
  {
    path: "login",
    component: LoginPage,
    data: {
      title: "Random Ride - Log In",
    },
  },
  {path: '**', redirectTo: ''}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// C:/Development/Private Projects/random-ride/RandomRide/src/app/app-routing.module.ts